import { ILiteRouterApiResponse } from "models/ILiteRouterApiResponse";
import {ICountryAsset, ICountryAssetLite} from "models/Assets/ICountryAsset";
import { ISeoCache } from "../types/types";

export default class SeoItemCityDescription {
  declare id: number;
  declare seo_item_id: number;
  declare city_id: number;
  declare page_description_ar: string;
  declare page_description_en: string;
}

export function getCityDescription(  seoCache: ISeoCache,
                                    seo_item_id: number, city_id: number) {
  return seoCache.getSeoItemCityDescriptionRecord(seo_item_id, city_id);
}